package com.evoapps.evoshift.kiosk

import com.evoapps.evoshift.domain.usecase.kiosk.KioskStore
import kotlinx.browser.localStorage

/** localStorage can be missing or throw (private windows): then the queue lives in memory only. */
actual fun platformKioskStore(key: String): KioskStore = object : KioskStore {
    private val fullKey = "evoshift.kiosk.$key"
    private var memory: String? = null
    override fun load(): String? = runCatching { localStorage.getItem(fullKey) }.getOrNull() ?: memory
    override fun save(value: String?) {
        memory = value
        runCatching { if (value == null) localStorage.removeItem(fullKey) else localStorage.setItem(fullKey, value) }
    }
}

actual fun platformKioskDeviceLock(): KioskDeviceLock = NoKioskDeviceLock
